import { ExpansionPanelFilter } from '~/shared/ui'
import { useFilters } from '../../../model'
import { StatusFilter } from '../items/status-filter'
import { ExpansionPanelLabel } from './expansion-panel-label'

export function FiltersContent() {
  const { filters, disabledFilters } = useFilters()

  return (
    <>
      <ExpansionPanelFilter
        label={
          <ExpansionPanelLabel
            filterKey="status"
            label="Status"
            disabled={!!disabledFilters.status}
          />
        }
        defaultExpanded
        withIndicator={filters.status.length > 0}
        disabled={!!disabledFilters.status}
        disabledTooltip={disabledFilters.status}
      >
        <StatusFilter />
      </ExpansionPanelFilter>
    </>
  )
}
